import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
const FINAL_STATUSES = [
  "deleted",
  "rejected",
  "archived"
];
export default function FormalityRequestStatusTimeline({
  currentStatus,
  isFront = true
}) {
  const config = useSelector((state) => state.config);
  const statuses = config?.formalities?.requests?.status || {};
  const [localStatus, setLocalStatus] = useState(currentStatus);
  const orderedStatuses = useMemo(() => {
    return Object.entries(statuses)
      .filter(
        ([key, status]) =>
          key !== "all" && status?.active !== false
      )
      .sort(([, a], [, b]) => (a.level ?? 0) - (b.level ?? 0));
  }, [statuses]);
  const currentIndex = orderedStatuses.findIndex(
    ([key]) => key === localStatus
  );
  const totalSteps = useMemo(
    () =>
      (orderedStatuses ?? []).filter(
        ([_, status]) => status?.isStep === true
      ).length,
    [orderedStatuses]
  );
  useEffect(() => {
    if (isFront && currentStatus === 'todo') {
      setLocalStatus('processed');
    }
    if (isFront && currentStatus === 'pending') {
      setLocalStatus('in_progress');

    }

  }, [currentStatus])
  return (
    <>
      {/* DESKTOP */}
      <div className="d-none d-lg-flex align-items-start gap-3 justify-content-between w-100">
        {orderedStatuses.map(([key, status]) => {

          if (isFront && ['todo', 'pending'].includes(key)) {
            return null;
          }
          const isCurrent = key === localStatus;
          const isFinal = FINAL_STATUSES.includes(key);
          if (isFinal && !isCurrent) return null;
          return (
            <div
              key={key}
              className={`d-flex flex-column align-items-center ${key}`}
              title={status.description}
            >
              <div
                style={{
                  width: 14,
                  height: 14,
                  borderRadius: "50%",
                  backgroundColor: isCurrent
                    ? status.color
                    : "#ced4da"
                }}
              />
              <div
                className={`text-center small mt-1 ${isCurrent ? "fw-semibold" : ""}`}
                style={{ color: isCurrent ? status.color : "#adb5bd" }}
              >
                {status.label}
              </div>
            </div>
          );
        })}
      </div>
      {/* MOBILE */}
      <div className="d-lg-none text-center py-2">
        {orderedStatuses[currentIndex] && (
          <>
            <div
              style={{
                width: 18,
                height: 18,
                borderRadius: "50%",
                margin: "0 auto",
                backgroundColor:
                  orderedStatuses[currentIndex][1].color
              }}
            />
            <div className="fw-semibold mt-2">
              {orderedStatuses[currentIndex][1].label}
            </div>
            <div className="small text-muted">
              Étape {currentIndex + 1} sur {totalSteps}
            </div>
          </>
        )}
      </div>
    </>
  );
}
